import React, { useCallback } from 'react';
import { LayoutAdminTable } from 'app/components/templates/LayoutAdminTable';
import { TabsCustom } from 'app/components/elements/TabsCutom';
import { TAB, useInjection } from './hook';
import { GridColDef, GridPaginationModel, GridRenderCellParams } from '@mui/x-data-grid';
import { Stack } from '@mui/material';
import theme from 'styles/theme';
import { ActiveTab } from './ArchiveTab';
import { AuctionDeliveryLocationTab } from './AuctionDeliveryLocationTab';
import { ClientOptionTab } from './ClientOptionTab';
import { Helmet } from 'react-helmet-async';

const HEADER: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 40 },
  { field: 'firstName', headerName: 'First Name', width: 130 },
  { field: 'lastName', headerName: 'Last Name', width: 130 },
  { field: 'address', headerName: 'Address', width: 250 },
  {
    field: 'email',
    headerName: 'Email',
    width: 250
  },
  {
    field: 'isActive',
    headerName: 'Account Status',
    width: 130,
    renderCell: (params: GridRenderCellParams) => {
      const isApproved = params?.value;
      return (
        <Stack
          style={{
            alignItems: 'flex-start',
            justifyContent: 'center',
            height: '100%'
          }}>
          <Stack
            style={{
              background: isApproved ? theme.colors.success : theme.colors.pending,
              alignItems: 'center',
              justifyContent: 'center',
              width: '90px',
              height: '36px',
              borderRadius: '20px'
            }}>
            {isApproved ? 'Active' : 'Inactive'}
          </Stack>
        </Stack>
      );
    }
  }
];

function ControlPanelPage() {
  const {
    tab,
    handleChangeTab,
    renderButtonHeader,
    onClickButtonHeader,
    tabHeader,
    asyncOnSubmitAuctionDelivery,
    asyncOnSubmitClient,
    handlePaginationModelChange,
    handleRowClick,
    loading,
    optionAuctionDelivery,
    optionClient,
    pages,
    rowStates,
    searchParams
  } = useInjection();

  const renderTab = useCallback(() => {
    const tab = (searchParams.get('tab') as keyof typeof TAB) || TAB.BAILIFFS;
    const { rows, total } = rowStates[tab] || {};
    if (tab === TAB.BAILIFFS)
      return (
        <ActiveTab
          header={HEADER}
          page={pages[tab]}
          totalRows={total}
          handlePaginationModelChange={(newPaginationModel: GridPaginationModel) =>
            handlePaginationModelChange(newPaginationModel, tab)
          }
          handleRowClick={handleRowClick}
          rows={rows}
          loading={loading}
        />
      );
    if (tab === TAB.ADMIN)
      return (
        <ActiveTab
          header={HEADER}
          page={pages[tab]}
          totalRows={total}
          handlePaginationModelChange={(newPaginationModel: GridPaginationModel) =>
            handlePaginationModelChange(newPaginationModel, tab)
          }
          handleRowClick={handleRowClick}
          rows={rows}
          loading={loading}
        />
      );
    if (tab === TAB.AUCTION)
      return (
        <AuctionDeliveryLocationTab
          optionInit={optionAuctionDelivery}
          onSubmitForm={asyncOnSubmitAuctionDelivery}
        />
      );
    if (tab === TAB.CLIENT)
      return <ClientOptionTab onSubmitForm={asyncOnSubmitClient} optionClientInit={optionClient} />;
    return <> </>;
  }, [
    asyncOnSubmitAuctionDelivery,
    asyncOnSubmitClient,
    handlePaginationModelChange,
    handleRowClick,
    loading,
    optionAuctionDelivery,
    optionClient,
    pages,
    rowStates,
    searchParams
  ]);

  return (
    <LayoutAdminTable
      title={'Control Panel'}
      textButton={renderButtonHeader()}
      onClickButton={onClickButtonHeader}>
      <Helmet>
        <title>Surrey Bailiffs - Control Panel</title>
      </Helmet>
      <TabsCustom
        tab={tab}
        contentTab={renderTab()}
        headerTab={tabHeader}
        onChangeTab={handleChangeTab}
      />
    </LayoutAdminTable>
  );
}

export default ControlPanelPage;
